/**
 * The phase-1 id lists, now derived from the registry (@hub/lib/registry)
 * so there is one vocabulary. Validators in @hub/lib/org-types keep
 * importing these names.
 */
import { BOTS, FEATURES, INTEGRATIONS } from "@hub/lib/registry";

export const FEATURE_IDS: readonly string[] = FEATURES.map((f) => f.id);
export const INTEGRATION_IDS: readonly string[] = INTEGRATIONS.map((i) => i.id);
export const BOT_IDS: readonly string[] = BOTS.map((b) => b.id);

/** Every switch on: what the Nymbl org is seeded with. */
export const ALL_SWITCHES = {
  features: [...FEATURE_IDS],
  integrations: [...INTEGRATION_IDS],
  bots: [...BOT_IDS],
};
